// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"21fed926","412":"0784b4d1","451":"23558ae7","453":"1e30e665","715":"b7aa84f4","785":"0fd7ca90","815":"016ba9ae","866":"f528711c","884":"1bd392f1","944":"fd7c2db3","962":"284c39ab"}[chunkId] + ".chunk.js";
};